"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SingleOTPInputComponent = SingleOTPInputComponent;
const react_1 = __importStar(require("react"));
const otpInput_styles_1 = require("./otpInput.styles");
const usePrevious_1 = __importDefault(require("./usePrevious"));
function SingleOTPInputComponent(props) {
    const { focus, autoFocus, value, isWide, index, dataTestId } = props, rest = __rest(props, ["focus", "autoFocus", "value", "isWide", "index", "dataTestId"]);
    const inputRef = (0, react_1.useRef)(null);
    const prevFocus = (0, usePrevious_1.default)(!!focus);
    (0, react_1.useLayoutEffect)(() => {
        if (inputRef.current) {
            if (focus && autoFocus) {
                inputRef.current.focus();
            }
            if (focus && autoFocus && focus !== prevFocus) {
                inputRef.current.focus();
                inputRef.current.select();
            }
        }
    }, [autoFocus, focus, prevFocus]);
    return (react_1.default.createElement(otpInput_styles_1.Input, Object.assign({ autoComplete: index === 0 ? 'one-time-code' : '', ref: inputRef }, rest, { isFocus: focus, value: value, isWide: isWide, type: "tel", placeholder: "\u25CF", "data-testid": dataTestId })));
}
exports.default = SingleOTPInputComponent;
//# sourceMappingURL=singleInput.js.map